// src/modules/app-views/account/pages/Init/modals/RemoveAccountModal/Step2.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleEmail from 'components/SimpleComponents/SimpleEmail';
import SimplePassword from 'components/SimpleComponents/SimplePassword';
import appService from 'services/appService';
import FirebaseService from 'services/FirebaseService';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const PasswordStepContent = () => (
  <>
    <SimpleEmail name="email" required disabled />
    <SimplePassword
      name="password"
      label="confirm_your_password"
      required
      autoComplete="current-password"
    />
  </>
);

// *******************************************************************************
// HELPERS
// *******************************************************************************
const validatePassword = async ({ form, setLoading, goFocus, storedUser }) => {
  const email = storedUser?.email?.value || storedUser?.email;
  const password = form?.getFieldValue('password');

  if (!password || password.trim() === '') {
    await appService.message({ flag: 'w', text: 'password_is_required' });
    goFocus?.('password', true);
    return false;
  }

  try {
    setLoading(true);
    await FirebaseService.reauthenticateUser(email, password);
    return true; // Allow proceed to next step
  } catch (reauthErr) {
    console.error('[RemoveAccountModal] Reauthentication error:', reauthErr);

    const errorCode = reauthErr?.message || '';
    if (
      errorCode.includes('auth/wrong-password') ||
      errorCode.includes('auth/invalid-credential')
    ) {
      await appService.message({ flag: 'e', text: 'incorrect_password' });
    } else {
      await appService.message({ flag: 'e', text: 'authentication_failed' });
    }

    // Focus back on password field when authentication fails
    goFocus?.('password', true);

    return false; // Don't proceed to next step
  } finally {
    setLoading(false);
  }
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const passwordStep = ({ storedUser }) => ({
  stepTitle: 'password',
  stepTooltip: 'confirm_your_password',
  content: () => <PasswordStepContent />,
  validationFields: ['password'],
  onNext: async ({ form, setLoading, goFocus }) =>
    validatePassword({ form, setLoading, goFocus, storedUser }),
  onEnter: ({ goFocus }) => {
    // Focus on the password field when entering this step
    setTimeout(() => goFocus?.('password'), 100);
  },
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default passwordStep;
